'use strict';

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class HorizontallyScrollableByMouse extends React.PureComponent {
    static propTypes = {
        children: PropTypes.element,
        hidden: PropTypes.bool,
        blocked: PropTypes.bool,
        attached: PropTypes.array
    };

    static defaultProps = {
        hidden: false,
        blocked: false,
        attached: []
    }

    initContainer = (elem) => {
        this.container = elem;
    };

    componentDidMount() {
        if (!this.props.blocked) {
            this.container.addEventListener('wheel', this.onWheel);
        }
    }

    componentWillUnmount() {
        if (!this.props.blocked) {
            this.container.removeEventListener('wheel', this.onWheel);
        }
    }

    onWheel = (event) => {
        const hasHorizontalScrollbar = this.container.scrollWidth > this.container.clientWidth;
        const { attached } = this.props;

        if (!hasHorizontalScrollbar) {
            return;
        }

        if (event.deltaY > 0) {
            this.container.scrollLeft += 100;
            attached.forEach(a => { a.container.scrollLeft += 100 });
        } else {
            this.container.scrollLeft -= 100;
            attached.forEach(a => { a.container.scrollLeft -= 100 });
        }

        event.preventDefault();
        event.stopPropagation();
    };

    render() {
        const className = classNames(this.props.className, 'horizontally-scrollable-by-mouse', this.props.hidden && 'horizontally-scrollable-by-mouse_hidden');

        return (
            <div className={className} ref={this.initContainer}>
                {this.props.children}
            </div>
        );
    }
}

export default HorizontallyScrollableByMouse;